module.exports = __webpack_public_path__ + "img/esport-banner-catalogue.ecbab17a.svg";